interface FaqItem {
  q: string;
  a: string;
}

const faqs: FaqItem[] = [
  {
    q: '51动漫需要注册才能观看吗？',
    a: '不需要。51动漫作为免费动漫在线观看平台，所有日漫、韩漫、国漫均无需注册即可直接观看，支持下拉式连续阅读，打开浏览器就能畅享全集内容。',
  },
  {
    q: '51动漫的资源更新频率是怎样的？',
    a: '51动漫每日同步更新热门连载动漫，与日本、韩国及国内各大平台保持同步。新番上线后48小时内即可在平台找到对应资源，完结番剧全集一次放出，追番不等待。',
  },
  {
    q: '移动端可以使用51动漫吗？',
    a: '完全可以。51动漫针对手机和平板做了全面适配，在浏览器中直接访问即可获得流畅的下拉式阅读体验。界面简洁直观，阅读进度自动保存，随时随地追番。',
  },
  {
    q: '51动漫涵盖哪些类型的动漫作品？',
    a: '平台覆盖日漫、韩漫、国漫三大品类，包含热血冒险、恋爱校园、奇幻异世界、悬疑推理、搞笑日常、科幻巨制、古风国风等全题材。目前资源库总量已超过20000部，持续扩充中。',
  },
  {
    q: '遇到加载问题或内容缺失怎么办？',
    a: '可尝试刷新页面或清除浏览器缓存。如问题持续存在，请通过"联系我们"模块反馈具体作品名称和章节，运营团队将在24小时内处理修复，确保阅读体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于51动漫平台使用的常见问题解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5 md:p-6">
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-3 flex items-start gap-3">
                <span className="text-primary-500 shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-7">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}